import PatientLayout from '@/components/patient/PatientLayout';
import type { PageProps } from './Show';
import TherapistJournalIndex from '../therapists/patients/journals/Index';
import type { TherapistJournalIndexProps } from '../therapists/patients/journals/Index';

type JournalsProps = PageProps & {
  entries: TherapistJournalIndexProps['entries'];
  pagination: TherapistJournalIndexProps['pagination'];
};

export default function Journals(props: JournalsProps) {
  const { patient, stats, charts, entries, pagination } = props;

  return (
    <PatientLayout
      patient={patient}
      stats={stats}
      charts={charts}
      activeTab="diary"
    >
      <TherapistJournalIndex
        patient={{ id: patient.id, display_name: patient.name }}
        entries={entries}
        pagination={pagination}
        hideChrome
      />
    </PatientLayout>
  );
}
